export { default as component } from "../../../../src/routes/[prefix]/(feature)/news/+page.svelte";